import { Flag, PenLine, Tag, UserPlus, Wand2 } from "lucide-react"

import type { FrontendTriggerDefinition } from "../../types"

export const contactTriggers: FrontendTriggerDefinition[] = [
  {
    key: "trigger__contact_updated",
    label: "Attribute changed",
    description: "Triggers when a contact attribute or custom field changes",
    icon: PenLine,
    providesSubjects: ["contact", "person"],
    inputFields: [
      {
        key: "watched_attributes",
        label: "When any of these change...",
        inputType: "multi_select",
        required: true,
        options: "dynamic_contact_attributes",
      },
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: false,
        filterEntity: "contact",
      },
    ],
  },
  {
    key: "trigger__contact_created",
    label: "Contact created",
    description: "Triggers when a new contact is created",
    icon: UserPlus,
    providesSubjects: ["contact", "person"],
    inputFields: [
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: false,
        filterEntity: "contact",
      },
    ],
  },
  {
    key: "trigger__contact_tag_added",
    label: "Tag added",
    description: "Triggers when a tag is added to a contact",
    icon: Tag,
    providesSubjects: ["contact", "person"],
    inputFields: [
      {
        key: "tag_ids",
        label: "When the new tag is...",
        inputType: "multi_select",
        required: true,
        options: "dynamic_tags",
      },
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: false,
        filterEntity: "contact",
      },
    ],
  },
  {
    key: "trigger__contact_sequence_completed",
    label: "Completed sequence",
    description: "Triggers when a contact completes or exits a sequence",
    icon: Flag,
    providesSubjects: ["contact", "person"],
    inputFields: [
      {
        key: "sequence_ids",
        label: "Sequences",
        inputType: "multi_select",
        required: false,
        options: "dynamic_sequences",
      },
      {
        key: "finish_reasons",
        label: "Finish reasons",
        inputType: "multi_select",
        required: false,
        options: [
          { value: "completed", label: "Completed all steps" },
          { value: "email_reply_received", label: "Email reply received" },
          { value: "meeting_scheduled", label: "Meeting scheduled" },
          { value: "manual_exit", label: "Manually exited" },
          { value: "unsubscribed", label: "Unsubscribed" },
          { value: "inbound_call_received", label: "Inbound call received" },
        ],
      },
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: false,
        filterEntity: "contact",
      },
    ],
  },
  {
    key: "trigger__contact_magic_button",
    label: "Magic button",
    description: "Triggers when a magic button is pressed for a contact",
    icon: Wand2,
    providesSubjects: ["contact", "person"],
    inputFields: [
      {
        key: "title",
        label: "Button title",
        inputType: "text",
        required: true,
        placeholder: "e.g., Request review",
      },
      {
        key: "description",
        label: "Description",
        inputType: "textarea",
        required: true,
        placeholder: "What does this button do?",
      },
      {
        key: "icon_color",
        label: "Icon & color",
        inputType: "icon_color_picker",
        required: true,
        chatDefaultValue: { icon: "wand", color: "#0EA5E9" },
        iconOptions: [
          "wand",
          "sparkles",
          "zap",
          "brain",
          "bot",
          "dollar",
          "coins",
          "banknote",
          "piggy-bank",
          "landmark",
          "chart-line",
          "chart-pie",
          "briefcase",
          "phone",
          "mail",
          "send",
          "calendar",
          "clock",
          "bell",
          "document",
          "household",
          "handshake",
          "star",
          "check",
        ],
        colorFormat: "hex",
      },
    ],
  },
]
